import { dictionaryCamelCaseConverter } from 'src/utils/dictionaryCamelCaseConverter';

export const sanitizeLanguages = (data) => dictionaryCamelCaseConverter(data);
